var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationWithDot = function SvgNotificationWithDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.793 16.495c-.52-.896-1.293-3.432-1.293-6.745a7.5 7.5 0 1 0-15.001 0c0 3.314-.774 5.849-1.295 6.745A1.5 1.5 0 0 0 4.5 18.751h3.826a3.75 3.75 0 0 0 7.349 0H19.5a1.5 1.5 0 0 0 1.293-2.256M12 20.251a2.25 2.25 0 0 1-2.12-1.5h4.241a2.25 2.25 0 0 1-2.12 1.5m-7.5-3c.722-1.242 1.5-4.118 1.5-7.5a6 6 0 0 1 12 0c0 3.38.777 6.256 1.5 7.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3.333,
    fill: "#FF0909",
    stroke: "#F1F1F1",
    strokeWidth: 1.333
  })));
};
export default SvgNotificationWithDot;